export class RetroAnalysisLoss {
    portfolioID: number;
    name: string;
    recordType: string;
    isLocked: boolean;
    isDeleted: boolean;
    allowEdit: boolean;
    adjPartPct: boolean;
    adjROL: boolean;
    processStatusID: number;
    reportProcessStatusID: number;
    addedToAnalysis: boolean;
    layerCount: number;
    tags: string[];
    categories: string[];
    classes: string[];
    statuses: string[];
    exposureRegions: string[];
    adjustmentType: number;
    disableAdjustedToggle: boolean;

    addToAnalysis: boolean;
    expandTable: boolean;

    // can the user add to analysis
    // can the user update useAdjPart or useAdjRol
    canModify: boolean;
    selectBoxTooltip: string;
    useAdjusted: boolean;
}

export class AddRetroLoss {
    portfolioID: number;
    useAdjPart: boolean;
    useAdjROL: boolean;
}

export class AddRetroLossParam {
    portfolios: Array<AddRetroLoss>;
}
